import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Breadcrumb, Button, Col, Form, Input, Row, Select } from 'antd';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getEcole } from 'app/entities/ecole/ecole.reducer';
import { createClasse, getClasse, reset, updateClasse } from './classe.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getCycles } from 'app/entities/cycle/cycle.reducer';

export const ClasseUpdate = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const classe = useAppSelector(state => state.classe.entity);
  const updating = useAppSelector(state => state.classe.updating);
  const updateSuccess = useAppSelector(state => state.classe.updateSuccess);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const cycles = useAppSelector(state => state.cycle.entities);
  const handleClose = () => {
    props.history.push(`/classe/${currentEcole && currentEcole.id}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      dispatch(getEcole(props.match.params.ecoleid));
      dispatch(getCycles(props.match.params.ecoleid));
    } else {
      dispatch(getClasse(props.match.params.id));
      dispatch(getEcole(props.match.params.ecoleid));
      dispatch(getCycles(props.match.params.ecoleid));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...classe,
      ...values,
      ecoleId: props.match.params.ecoleid,
    };

    if (isNew) {
      dispatch(createClasse(entity));
    } else {
      dispatch(updateClasse(entity));
    }
  };
  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...classe,
        };
  const { match } = props;
  return (
    <div>
      {isNew ? (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/classe/${currentEcole && currentEcole.id}`}>Classes</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/classe/${currentEcole && currentEcole.id}`}>Classes</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${match.url}`}>Details</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      )}

      <Row className="justify-content-center">
        <Col span={18} offset={4}>
          {isNew ? (
            <h2 id="korischoolApp.classe.home.createLabel" data-cy="ClasseCreateUpdateHeading">
              <Translate contentKey="korischoolApp.classe.home.createLabel">Create a Classe</Translate>
            </h2>
          ) : (
            <h2 id="korischoolApp.classe.home.editLabel" data-cy="ClasseCreateUpdateHeading">
              <Translate contentKey="korischoolApp.classe.home.editLabel">Edit a Classe</Translate>
            </h2>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col span={18} offset={4}>
          <Form
            labelCol={{ span: 4 }}
            onFinish={saveEntity}
            wrapperCol={{ span: 14 }}
            layout="vertical"
            size="large"
            initialValues={!isNew && classe}
          >
            <Form.Item label="classe" name="nom">
              <Input placeholder="classe" />
            </Form.Item>
            <Form.Item label="Cycle" name="cycleId">
              <Select placeholder="Sélectionner un cycle" allowClear>
                {cycles.map(cycle => (
                  <Select.Option key={cycle.id} value={cycle.id}>
                    {cycle.nom}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                data-cy="entityCreateSaveButton"
                htmlType="submit"
                disabled={updating}
                id="save-entity"
              >
                <FontAwesomeIcon icon="save" />
                &nbsp; Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default ClasseUpdate;
